import { Modal } from '../modal'

interface StartReviewModalProps {
  isOpen: boolean
  setOpen: (value: boolean) => void
  submitButtonAction?: () => void
  isPendingStartReview?: boolean
}

export const StartReviewModal = ({
  isOpen,
  setOpen,
  submitButtonAction,
  isPendingStartReview,
}: StartReviewModalProps) => {
  return (
    <Modal
      backButtonLabel="Cancelar"
      submitButtonLabel="Iniciar"
      title="Iniciar Análise"
      submitButtonclassName="bg-[var(--brand-green)]"
      submitAction={submitButtonAction}
      pendingSubmit={isPendingStartReview}
      isOpen={isOpen}
      setOpen={setOpen}
    >
      <div className="flex flex-col gap-10">
        <p>
          Confirmando esta ação{' '}
          <strong>
            o status da análise passará para “Em análise” informando o
            aluno/candidato
          </strong>{' '}
          que a solicitação entrou em processo de verificação para ver quais
          disciplinas poderão ser aproveitadas
        </p>

        <div>
          <p>
            <strong>Deseja realmente iniciar a análise?</strong>
          </p>
          <p>
            <strong>
              Esta solicitação será transferida para a página das suas análises
            </strong>
          </p>
        </div>
      </div>
    </Modal>
  )
}
